import React, { useState } from 'react';
import cls from './Layout.module.scss';
import { CustomerAgentIcon } from 'src/assets/icons/scins';
import UserDropdown from './UserBar/UserDropdown/UserDropdown';
import ContactsPopup from './UserBar/ContactsPopup/ContactsPopup';
import { useTranslation } from 'react-i18next';
import Tooltip from '../UI/Tooltip/Tooltip';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import selectors from 'src/redux/selectors';
import Notifications from './UserBar/Notifications';
import useUserInfo from 'src/hooks/user/useUserInfo';
import GearCancelIcon from 'src/assets/icons/gears/GearCancelIcon';
import { useAppDispatch, useAppSelector } from 'src/redux';
import { resetFilters } from 'src/redux/slices/tableDataOperations';
import { NavLink } from 'react-router-dom';
import { PAGES_ENUM } from '../../routes';
import calculateRemainingDays from '../../utils/helpers/calculateRemainingDays';

const Header = () => {
  useUserInfo();
  const { t } = useTranslation('translation', { keyPrefix: 'header' });
  const userData = useTypedSelector(selectors.getUser);
  const [contactsPopupShow, setContactsPopupShow] = useState<boolean>(false);
  const isAuth = useTypedSelector(selectors.getUserId);
  const hasFilters = useAppSelector(selectors.getHasFilters);
  const dispatch = useAppDispatch();
  const resetParamsHandler = () => {
    dispatch(resetFilters());
  };

  return (
    <header className={cls.header}>
      {isAuth && (
        <div className={cls.user_bar}>
          {userData?.subscription ? (
            <div className={cls['tariff-info']}>
              <p className={cls['tariff-info-text']}>
                {t('t-tariff-title')}{' '}
                <NavLink
                  className={cls['tariff-info-link']}
                  to={PAGES_ENUM.SUBSCRIPTIONS}
                >
                  {userData?.subscription?.['SubscriptionType']?.name}
                </NavLink>
              </p>
              <p className={cls['tariff-info-text']}>
                {t('t-remaining-tariff', {
                  value: calculateRemainingDays(
                    userData?.subscription?.end_date
                  ),
                })}
              </p>
            </div>
          ) : null}
          <div className="header-portal" />

          <Tooltip title={t('t-title-reset-params')}>
            <GearCancelIcon
              className={`header-icon ${cls['reset-params']} ${hasFilters && cls['active']}`}
              onClick={resetParamsHandler}
            />
          </Tooltip>
          {/*<Tooltip title={t('t-title-profile')}>*/}

          <UserDropdown />
          {/*</Tooltip>*/}
          <Notifications />
          <Tooltip title={t('t-title-contacts')}>
            <CustomerAgentIcon
              className={'header-icon stroke-path'}
              onClick={() => {
                setContactsPopupShow(true);
              }}
            />
          </Tooltip>
        </div>
      )}
      {/*{userDropdownShow && (*/}
      {/*  <UserDropdown*/}
      {/*    show={userDropdownShow}*/}
      {/*    close={() => {*/}
      {/*      setUserDropdownShow(false);*/}
      {/*    }}*/}
      {/*  />*/}
      {/*)}*/}

      {contactsPopupShow && (
        <ContactsPopup
          show={contactsPopupShow}
          close={() => {
            setContactsPopupShow(false);
          }}
        />
      )}
    </header>
  );
};
export default Header;
